import { Button, Checkbox, FormControl, Grid, InputLabel, MenuItem, NativeSelect, Select, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import InfluencerTemplate from '../../../assets/Clients/Boticario/Influenciadores-template.xlsx';
import { useInputStyles } from '../../../shared/components/UploadStyles';
import { BasicDropzone } from '../../../shared/components/BasicDropzone';
import { HomeContext } from '../../Home/HomeContext';

interface UploadInputProps {
    uploadSpreadsheet: (file: File) => void,
    selectedSubmitOption: string, 
    setSelectedSubmitOption: (selectedSubmitOption:string)=>void
}

export default function InfluencerSubmitInput({
    uploadSpreadsheet,
    selectedSubmitOption, 
    setSelectedSubmitOption,
}:UploadInputProps){
    const classes = useInputStyles();
    const homeContext = React.useContext(HomeContext);
    
    const [file, setFile] = React.useState<File | null>(null);
    
    function getDisabledSubmit() {
        return (file == null);
    }

    const handleSelectChange = (event:any) => {
      setSelectedSubmitOption(event.target.value);
    };

    const planilhaTemplates: Record<string, string>={
        'Influenciadores':InfluencerTemplate,
        'Campanhas':InfluencerTemplate,
        'Empresas':InfluencerTemplate,
      };
    const linkPlanilha = planilhaTemplates[selectedSubmitOption];

    const handleDownload = ()=>{
        if (!selectedSubmitOption) {
            homeContext.showError('Por favor, selecione uma opção de Submissão.<br/>');
            return;
        }

        const link = document.createElement('a');
        link.href = linkPlanilha;
        link.download = `${selectedSubmitOption}-template.xlsx`;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    
     
    return(
        <>
        <Grid
            container
            direction="column"
            justify="center"
            alignItems="center">
            <Button
                size="large"
                variant="contained"
                color="primary"
                className={classes.fields}
                style={{marginTop:'5rem'}}
                onClick={handleDownload}
            >
                Baixar modelo de planilha
            </Button>
            <Grid
            xs="auto"
            >
                <FormControl  className={classes.fields} 
                variant='standard'
                >
                    <InputLabel id="submit-select" style={{color:'black'}}>Selecione o Tipo de Submissão</InputLabel>
                    <Select
                    labelId="submit-select"
                    id="submit-select"
                    value={selectedSubmitOption} 
                    onChange={handleSelectChange}
                    style={{
                        marginTop:'2.5rem',
                        outline:'none',
                        borderBottom:'none',
                    }}
                >
                        <MenuItem value={'Influenciadores'}><Checkbox checked={selectedSubmitOption.includes('Influenciadores')}/>Influenciadores</MenuItem>
                        <MenuItem value={'Campanhas'}><Checkbox checked={selectedSubmitOption.includes('Campanhas')}/>Campanhas</MenuItem>
                        <MenuItem value={'Empresas'}><Checkbox checked={selectedSubmitOption.includes('Empresas')}/>Empresas</MenuItem>
                    </Select>
                </FormControl>

            </Grid>
            <Grid>
                <BasicDropzone onChangefile={(file: File) => setFile(file)} isClipperSpreadsheetUpload={false} isInfluencerSpreadsheetUpload={true} />
            </Grid>
            <Grid>
                <Button
                    size="large"
                    variant="contained"
                    color="primary"
                    className={classes.fields}
                    disabled={getDisabledSubmit()}
                    onClick={() => { if (file) { uploadSpreadsheet(file); } }}>
                    Enviar
                </Button>
            </Grid>
        </Grid>
    </>
    );
}